export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="px-4 md:px-10 pt-16 md:pt-24 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 md:gap-14">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50">
                <i className="ri-leaf-line text-primary-600 text-xl"></i>
              </span>
              <span className="font-heading text-3xl font-semibold text-background-50">PureNest</span>
            </div>
            <p className="text-background-200/80 text-sm leading-relaxed max-w-md mb-8">
              A modern marketplace for trusted, vetted home cleaners. We exist so coming home always feels a little lighter.
            </p>
            <div className="flex items-center gap-3">
              {["instagram-line", "facebook-circle-line", "tiktok-line", "linkedin-line"].map((i) => (
                <a
                  key={i}
                  href="#"
                  aria-label={i}
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-background-50/30 text-background-50 hover:bg-background-50 hover:text-primary-700 transition-colors"
                >
                  <i className={`ri-${i} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3 grid grid-cols-2 gap-8">
            <div>
              <h4 className="text-xs uppercase tracking-widest text-background-50 mb-4">Visit</h4>
              <p className="text-background-200/80 text-sm leading-relaxed">
                240 Brookline Ave<br />
                Suite 401<br />
                Cambridge, MA 02139
              </p>
            </div>
            <div>
              <h4 className="text-xs uppercase tracking-widest text-background-50 mb-4">Contact</h4>
              <p className="text-background-200/80 text-sm leading-relaxed">
                <a href="tel:+16175550199" className="hover:text-background-50">(617) 555-0199</a><br />
                <a href="mailto:hi@purenest.com" className="hover:text-background-50">hi@purenest.com</a><br />
                Mon–Sun · 7am–9pm
              </p>
            </div>
          </div>

          <div className="lg:col-span-4">
            <div className="rounded-2xl overflow-hidden h-64 lg:h-full">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20warm%20home%20interior%20with%20sunlight%20streaming%20through%20linen%20curtains%20onto%20a%20wooden%20floor%20with%20small%20olive%20plant%20and%20linen%20cushion%2C%20editorial%20interior%20photography%20serene%20neutral%20warm%20palette%20calm%20atmosphere&width=1000&height=900&seq=footer-img-01&orientation=portrait"
                alt="Sunlit cozy living room"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="border-t border-background-50/15 mt-12 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-background-200/70">© 2026 PureNest Home Services, LLC. All rights reserved.</p>
          <ul className="flex flex-wrap items-center gap-6 text-xs text-background-200/70">
            <li><a href="#" className="hover:text-background-50">Privacy</a></li>
            <li><a href="#" className="hover:text-background-50">Terms</a></li>
            <li><a href="#" className="hover:text-background-50">Cleaner Careers</a></li>
            <li>
              <a
                href="/admin/login"
                className="inline-flex items-center gap-1.5 hover:text-background-50"
              >
                <i className="ri-shield-keyhole-line text-sm"></i>
                Admin sign in
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}